import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_sentryserver_2f82c23a from 'nuxt_plugin_sentryserver_2f82c23a' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_faf5a54a from 'nuxt_plugin_sentryclient_faf5a54a' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_loggerPlugin_4a84e54c from 'nuxt_plugin_loggerPlugin_4a84e54c' // Source: ./loggerPlugin.ts (mode: 'all')
import nuxt_plugin_cachePlugin_ed5b88d4 from 'nuxt_plugin_cachePlugin_ed5b88d4' // Source: ./cachePlugin.ts (mode: 'all')
import nuxt_plugin_shopConfigPlugin_3b6fb104 from 'nuxt_plugin_shopConfigPlugin_3b6fb104' // Source: ./shopConfigPlugin.ts (mode: 'all')
import nuxt_plugin_routerPlugin_564db89a from 'nuxt_plugin_routerPlugin_564db89a' // Source: ./routerPlugin.ts (mode: 'client')
import nuxt_plugin_libplugin9eeeb2ae_9497d2fa from 'nuxt_plugin_libplugin9eeeb2ae_9497d2fa' // Source: ./lib.plugin.9eeeb2ae.js (mode: 'all')
import nuxt_plugin_gtm_164530b5 from 'nuxt_plugin_gtm_164530b5' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_nuxtenv_4ae7d6d6 from 'nuxt_plugin_nuxtenv_4ae7d6d6' // Source: ./nuxt-env.js (mode: 'all')
import nuxt_plugin_vuescrollto_66fe470a from 'nuxt_plugin_vuescrollto_66fe470a' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_axios_0a5d23c2 from 'nuxt_plugin_axios_0a5d23c2' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_apollomodule_120faaeb from 'nuxt_plugin_apollomodule_120faaeb' // Source: ./apollo-module.js (mode: 'all')
import nuxt_plugin_opentracing_044d41eb from 'nuxt_plugin_opentracing_044d41eb' // Source: ../plugins/opentracing.ts (mode: 'server')
import nuxt_plugin_apolloOverrides_72f667ea from 'nuxt_plugin_apolloOverrides_72f667ea' // Source: ../plugins/apolloOverrides.ts (mode: 'all')
import nuxt_plugin_prometheus_0574464d from 'nuxt_plugin_prometheus_0574464d' // Source: ../plugins/prometheus.ts (mode: 'all')
import nuxt_plugin_webComponentsConfiguration_22177c6b from 'nuxt_plugin_webComponentsConfiguration_22177c6b' // Source: ../plugins/webComponentsConfiguration.ts (mode: 'all')
import nuxt_plugin_i18n_1fba4fce from 'nuxt_plugin_i18n_1fba4fce' // Source: ../plugins/i18n.ts (mode: 'all')
import nuxt_plugin_translateProductVariantStickers_1015db2e from 'nuxt_plugin_translateProductVariantStickers_1015db2e' // Source: ../plugins/translateProductVariantStickers.ts (mode: 'all')
import nuxt_plugin_translator_12f4c71d from 'nuxt_plugin_translator_12f4c71d' // Source: ../plugins/translator.ts (mode: 'all')
import nuxt_plugin_resize_20be497a from 'nuxt_plugin_resize_20be497a' // Source: ../plugins/resize.ts (mode: 'all')
import nuxt_plugin_progressBar_32646086 from 'nuxt_plugin_progressBar_32646086' // Source: ../plugins/progressBar.ts (mode: 'all')
import nuxt_plugin_abTest_70619344 from 'nuxt_plugin_abTest_70619344' // Source: ../plugins/abTest.ts (mode: 'all')
import nuxt_plugin_toaster_70c3bd8f from 'nuxt_plugin_toaster_70c3bd8f' // Source: ../plugins/toaster.ts (mode: 'all')
import nuxt_plugin_polyfills_473a241f from 'nuxt_plugin_polyfills_473a241f' // Source: ../plugins/polyfills.ts (mode: 'client')
import nuxt_plugin_gtm_63637dfa from 'nuxt_plugin_gtm_63637dfa' // Source: ../plugins/gtm.ts (mode: 'client')
import nuxt_plugin_pageLoad_e0b36c7c from 'nuxt_plugin_pageLoad_e0b36c7c' // Source: ../plugins/pageLoad.ts (mode: 'client')
import nuxt_plugin_errorPages_2dc0314a from 'nuxt_plugin_errorPages_2dc0314a' // Source: ../plugins/errorPages.ts (mode: 'client')
import nuxt_plugin_analytics_2e48c45d from 'nuxt_plugin_analytics_2e48c45d' // Source: ../plugins/analytics.ts (mode: 'client')
import nuxt_plugin_liveData_5f5390fe from 'nuxt_plugin_liveData_5f5390fe' // Source: ../plugins/liveData.ts (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const store = null
  const router = await createRouter(ssrContext, config, { store })

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"meta":[{"charset":"utf-8"},{"content":"width=device-width, initial-scale=1","name":"viewport"},{"content":"noindex","name":"robots"},{"content":"noindex","name":"googlebot"}],"link":[],"style":[],"script":[{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e].p&&e[e][p]()))?1:0})(window,'navigator','doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":""}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_2f82c23a === 'function') {
    await nuxt_plugin_sentryserver_2f82c23a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_faf5a54a === 'function') {
    await nuxt_plugin_sentryclient_faf5a54a(app.context, inject)
  }

  if (typeof nuxt_plugin_loggerPlugin_4a84e54c === 'function') {
    await nuxt_plugin_loggerPlugin_4a84e54c(app.context, inject)
  }

  if (typeof nuxt_plugin_cachePlugin_ed5b88d4 === 'function') {
    await nuxt_plugin_cachePlugin_ed5b88d4(app.context, inject)
  }

  if (typeof nuxt_plugin_shopConfigPlugin_3b6fb104 === 'function') {
    await nuxt_plugin_shopConfigPlugin_3b6fb104(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_routerPlugin_564db89a === 'function') {
    await nuxt_plugin_routerPlugin_564db89a(app.context, inject)
  }

  if (typeof nuxt_plugin_libplugin9eeeb2ae_9497d2fa === 'function') {
    await nuxt_plugin_libplugin9eeeb2ae_9497d2fa(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_164530b5 === 'function') {
    await nuxt_plugin_gtm_164530b5(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtenv_4ae7d6d6 === 'function') {
    await nuxt_plugin_nuxtenv_4ae7d6d6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_66fe470a === 'function') {
    await nuxt_plugin_vuescrollto_66fe470a(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_0a5d23c2 === 'function') {
    await nuxt_plugin_axios_0a5d23c2(app.context, inject)
  }

  if (typeof nuxt_plugin_apollomodule_120faaeb === 'function') {
    await nuxt_plugin_apollomodule_120faaeb(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_opentracing_044d41eb === 'function') {
    await nuxt_plugin_opentracing_044d41eb(app.context, inject)
  }

  if (typeof nuxt_plugin_apolloOverrides_72f667ea === 'function') {
    await nuxt_plugin_apolloOverrides_72f667ea(app.context, inject)
  }

  if (typeof nuxt_plugin_prometheus_0574464d === 'function') {
    await nuxt_plugin_prometheus_0574464d(app.context, inject)
  }

  if (typeof nuxt_plugin_webComponentsConfiguration_22177c6b === 'function') {
    await nuxt_plugin_webComponentsConfiguration_22177c6b(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_1fba4fce === 'function') {
    await nuxt_plugin_i18n_1fba4fce(app.context, inject)
  }

  if (typeof nuxt_plugin_translateProductVariantStickers_1015db2e === 'function') {
    await nuxt_plugin_translateProductVariantStickers_1015db2e(app.context, inject)
  }

  if (typeof nuxt_plugin_translator_12f4c71d === 'function') {
    await nuxt_plugin_translator_12f4c71d(app.context, inject)
  }

  if (typeof nuxt_plugin_resize_20be497a === 'function') {
    await nuxt_plugin_resize_20be497a(app.context, inject)
  }

  if (typeof nuxt_plugin_progressBar_32646086 === 'function') {
    await nuxt_plugin_progressBar_32646086(app.context, inject)
  }

  if (typeof nuxt_plugin_abTest_70619344 === 'function') {
    await nuxt_plugin_abTest_70619344(app.context, inject)
  }

  if (typeof nuxt_plugin_toaster_70c3bd8f === 'function') {
    await nuxt_plugin_toaster_70c3bd8f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_polyfills_473a241f === 'function') {
    await nuxt_plugin_polyfills_473a241f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtm_63637dfa === 'function') {
    await nuxt_plugin_gtm_63637dfa(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pageLoad_e0b36c7c === 'function') {
    await nuxt_plugin_pageLoad_e0b36c7c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_errorPages_2dc0314a === 'function') {
    await nuxt_plugin_errorPages_2dc0314a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_analytics_2e48c45d === 'function') {
    await nuxt_plugin_analytics_2e48c45d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_liveData_5f5390fe === 'function') {
    await nuxt_plugin_liveData_5f5390fe(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
